import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { useTransition, animated } from 'react-spring';
import GameContext from 'contexts/game';
import LocaleContext from 'contexts/locale';
import useGameConnection from 'hooks/useGameConnection';
import Loader from 'atoms/Loader';
import Lobby from './Game/Lobby';
import Live from './Game/Live';

const Game = (props) => {
    const history = useHistory();
    const params = useParams();
    const { game, player, superAdmin, error, connection } = useGameConnection(params.code.toUpperCase());
    const context = useMemo(() => ({ connection, superAdmin }), [connection, superAdmin]);
    const transitions = useTransition(game?.status, {
        from: { opacity: 1 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
    });

    useEffect(() => {
        if (error === 'GAME_DOES_NOT_EXIST') {
            history.replace('/');
        }
    }, [error]);

    // After a rematch, everyone in the game follows the admin to the new one
    useEffect(() => {
        if (!connection) {
            return undefined;
        }

        return connection.onRematch((code) => {
            history.push(`/${code}`);
        });
    }, [connection]);

    if (!game) {
        return (
            <Loader />
        );
    }

    return (
        <GameContext.Provider value={context}>
            <LocaleContext.Provider value={game.language}>
                {transitions((styles, status) => (
                    <animated.div style={styles}>
                        {(status === 'LIVE' || status === 'DONE') && (
                            <Live
                                game={game}
                                player={player}
                                spring={props.spring}
                            />
                        )}

                        {status === 'PENDING' && (
                            <Lobby
                                game={game}
                                player={player}
                                spring={props.spring}
                            />
                        )}
                    </animated.div>
                ))}
            </LocaleContext.Provider>
        </GameContext.Provider>
    );
};

Game.propTypes = {
    spring: PropTypes.object.isRequired,
};

export default Game;
